import React from 'react';
import { PrevButton, NextButton, DotButton } from './CarouselButtons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import 'swiper/swiper.min.css';

export const ImageCarousel = ({ slides, media, productName }) => {
  const { t } = useTranslation();
  return (
    <SwiperCustom
      spaceBetween={50}
      slidesPerView={1}
      autoHeight
      speed={500}
      pagination={{ el: null }}
      navigation={{ nextEl: null, prevEl: null }}
      onBeforeInit={(swiper) => {
        swiper.navigation.init();
        swiper.navigation.update();
        swiper.pagination.init();
        swiper.pagination.update();
      }}
      modules={[Pagination, Navigation]}
      key={slides.length}
    >
      {media?.length > 0
        ? media.map(({ alt, src }, i) => (
            <SwiperSlide key={i} className="awt-img-carousel-slide">
              <ImageCarouselSlideImage
                src={src}
                alt={alt}
                aria-label={t('aria_labels.carousel_image', {
                  index: i + 1,
                  total: slides.length,
                })}
              />
            </SwiperSlide>
          ))
        : slides.map((slide, i) => (
            <SwiperSlide key={i} className="awt-img-carousel-slide">
              <ImageCarouselSlideImage
                src={slide}
                alt={productName}
                aria-label={t('aria_labels.carousel_image', {
                  index: i + 1,
                  total: slides.length,
                })}
              />
            </SwiperSlide>
          ))}
      <PrevButton />
      <NextButton />
      <ImageCarouselDotsContainer>
        {slides.map((_slide, i) => (
          <DotButton key={i} index={i} total={slides.length} />
        ))}
      </ImageCarouselDotsContainer>
    </SwiperCustom>
  );
};

const SwiperCustom = styled(Swiper).attrs({
  className: 'awtomic-image-carousel',
})`
  padding: 0px 16px;
`;

const ImageCarouselSlideImage = styled.img.attrs({
  className: 'awt-img-carousel-slide-image',
})`
  display: inline-block;
  width: 100%;
  margin-top: 15px;
`;

const ImageCarouselDotsContainer = styled.div.attrs({
  className: 'awt-img-carousel-dots-container',
})`
  display: flex;
  list-style: none;
  justify-content: center;
  padding-top: 10px;
`;
